import { useNavigate, useLocation } from "react-router-dom";

const AnchorLink = ({ to, children, className, onClick }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e) => {
    e.preventDefault();
// eslint-disable-next-line no-unused-vars
    const [pathname, hash] = to.split("#");

    if (location.pathname !== "/") {
      // Сохраняем якорь и переходим на главную
      sessionStorage.setItem("scrollToHash", hash);
      navigate("/");
    } else {
      // Уже на главной — просто скроллим
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }

    onClick?.();
  };

  return (
    <a href={to} onClick={handleClick} className={className}>
      {children}
    </a>
  );
};

export default AnchorLink;
